import React, { useMemo, useState } from 'react'

import { useTranslation } from 'react-i18next'
import { Search } from 'Assets/icons/Search'
import { Plus } from 'Assets/icons/Plus'
import {
  TopLeft,
  TopRight,
  UserManagementStyled,
  UserManagementTitle,
  UserManagementTop,
  UserManagementSearch,
} from './UserManagement.styled'
import { useGetUsers } from 'Features/accountSettings/api/getUsers'
import { UserManagementTable } from 'Features/accountSettings/components/UserManagement/UserManagmentTable/UserManagementTable'
import { AddEditUserModal } from 'Features/accountSettings/components/UserManagement/AddEditUserModal/AddEditUserModal'
import { InputWithIcon, ButtonWithIcon } from '@clickcease/cc-client-components-lib'

export const UserManagement = () => {
  const [showAddEditUserModal, setShowAddEditUserModal] = useState<boolean>(false)
  const [search, setSearch] = useState<string>('')
  const { t } = useTranslation('accountSettings')

  const users = useGetUsers()

  const usersData = useMemo(() => {
    if (!(users.data instanceof Error)) {
      if (users.data && search.length > 0) {
        return users.data.users.filter((user) => {
          return (
            user.name.toLowerCase().includes(search.toLowerCase()) ||
            user.email.toLowerCase().includes(search.toLowerCase())
          )
        })
      } else {
        return users.data ? users.data.users : []
      }
    }
  }, [users, search])

  const getNumOfUsers = () => {
    return usersData ? usersData.length : 0
  }

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearch(e.target.value)
  }

  return (
    <UserManagementStyled id={'account-settings-user-management-tab'}>
      <UserManagementTop>
        <TopLeft>
          <UserManagementTitle>
            {t('user_management.title', { count: getNumOfUsers() })}
          </UserManagementTitle>
          <UserManagementSearch>
            <InputWithIcon
              value={search}
              placeholder={t('user_management.search')}
              onChange={handleInputChange}
              iconLeft={<Search />}
            />
          </UserManagementSearch>
        </TopLeft>
        <TopRight>
          <ButtonWithIcon
            iconLeft={<Plus />}
            variant="outline"
            style={{ width: '111px' }}
            text={t('user_management.add_user')}
            onClick={() => setShowAddEditUserModal(true)}
          />
        </TopRight>
      </UserManagementTop>
      <UserManagementTable users={usersData || []} />
      <AddEditUserModal
        isOpen={showAddEditUserModal}
        onOpenChange={() => setShowAddEditUserModal(false)}
      />
    </UserManagementStyled>
  )
}
